import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartpocket/src/components/seo/StructuredDataScripts.tsx");
